<template>
  <div>
    <div class="ui icon buttons">
      <button type="button" class="ui button" @click="run" :class="{ disabled: isPlayDisabled }">
        <i class="play icon" />
      </button>
      <button type="button" class="ui button" @click="debug" :class="{ disabled: isDebugDisabled }">
        <i class="bug icon" />
      </button>
      <button
        type="button"
        class="ui button"
        v-if="editorMode === 'debugger'"
        @click="pauseFlow"
        :class="{ disabled: isPauseDisabled }"
      >
        <i class="pause icon" />
      </button>
      <button
        type="button"
        class="ui button"
        v-if="editorMode === 'debugger'"
        @click="stopFlow"
        :class="{ disabled: isStopDisabled }"
      >
        <i class="stop icon" />
      </button>
      <button
        type="button"
        class="ui button"
        v-if="editorMode === 'debugger'"
        @click="forwardFlow"
        :class="{ disabled: isForwardDisabled }"
      >
        <i class="step forward icon" />
      </button>
    </div>
  </div>
</template>

<script>
// @flow
import Vue from 'vue'
import { mapFields } from 'vuex-map-fields'
import { mapGetters, mapActions } from 'vuex'
import { FlowStateEnum } from 'enums'
import _ from 'lodash'

export default {
  name: 'DebugButtons',
  computed: {
    ...mapFields('debugger', ['flowDebugState']),
    ...mapFields('flowEditor', ['editorMode']),
    flow() {
      return this.$store.state.flowEditor.flow || {}
    },
    flowDebugState() {
      return this.$store.state.debugger.flowDebugState
    },
    isPlayDisabled() {
      return (
        this.flowDebugState === FlowStateEnum.RUNNING ||
        this.flowDebugState === FlowStateEnum.DEBUGGING
      )
    },
    isDebugDisabled() {
      return this.flowDebugState !== FlowStateEnum.STOPPED
    },
    isPauseDisabled() {
      return this.flowDebugState !== FlowStateEnum.RUNNING
    },
    isStopDisabled() {
      return this.flowDebugState === FlowStateEnum.STOPPED
    },
    isForwardDisabled() {
      return this.flowDebugState !== FlowStateEnum.PAUSED
    }
  },
  methods: {
    ...mapActions('debugger', ['stopFlow', 'pauseFlow', 'forwardFlow', 'runCodeInEditor']),
    run() {
      if (!_.isEmpty(this.flow)) {
        this.runCodeInEditor(false)
      }
    },
    debug() {
      if (!_.isEmpty(this.flow)) {
        this.runCodeInEditor(true)
      }
      this.changeToDebuggerTab()
    },
    changeToDebuggerTab() {
      this.$router.push({
        name: 'app-flow',
        params: {
          appId: this.flow.application,
          flowId: this.flow.id,
          mode: 'debugger'
        }
      })
    }
  }
}
//
</script>
